import get from 'lodash.get';
import { IntlShape } from 'react-intl';

export function findItemByPath<T>(arr: T[], path: string, value: unknown): T | undefined {
  return arr.find((item) => get(item, path) === value);
}

export function getTypedObjectEntries<T extends object = object>(o: T) {
  return Object.entries(o) as {
    [K in keyof T]-?: [K, T[K]];
  }[keyof T][];
}

export const formatListWithAnd = (
  items: string[],
  formatMessage: IntlShape['formatMessage'],
): string => {
  if (items.length === 0) return '';
  const lastIndex = items.length - 1;

  return items
    .map((item, i) => {
      switch (i) {
        case lastIndex - 1:
          return `${item} ${formatMessage({ id: 'and' })} `;
        case lastIndex:
          return item;
        default:
          return `${item}, `;
      }
    })
    .join('');
};

export function formatList<T extends string | { name: string }>(
  items: T[],
  separator = ', ',
): string {
  return items.map((item) => (typeof item === 'string' ? item : item.name)).join(separator);
}
